import { network } from 'services/network';

export const getOpcProjectsList = () => {
    return network.post('api/bo/getOpcProjectsList').then((response) => response.data);
};
